import * as React from 'react';

import useRecentArticles from '@research-api/utils/hooks/useRecentArticles';

import RecentResearch from '@/components/sections/Right/RecentResearch';

type RecentResearchFetchableProps = {
    limit?: number;
    hideHeader?: boolean;
    className?: string;
};

const RecentResearchFetchable = ({ limit, hideHeader, className }: RecentResearchFetchableProps) => {
    const { articles } = useRecentArticles({ limit: limit ?? 1 });

    if (articles.length === 0) {
        return null;
    }

    return (
        <>
            {articles.map(article => (
                <RecentResearch
                    key={article.slug}
                    recentResearch={article}
                    hideHeader={hideHeader}
                    className={className}
                />
            ))}
        </>
    );
};

export default RecentResearchFetchable;
